import UserService from '@/common/API/UserService';
import FormFactory from '@/components/FormFactory';
import Input from '@/components/forms/Input';
import Screen from '@/components/layout/Screen';
import { Button } from '@/components/ui/button';
import { Field } from 'formik';
import React, { MutableRefObject, useRef } from 'react';

const PasswordChangeScreen = () => {
  const formRef: MutableRefObject<any> = useRef();

  return (
    <Screen
      screenOptions={{
        header: {
          title: 'Personal information',
          backBtnLabel: 'Settings',
          backBtnUrl: './../',
          titleClassName: 'text-white',
        },
      }}
      screenContainerClassName='bg-black'
      className='grid grid-rows-5 px-4'
    >
      <FormFactory
        formRef={formRef}
        className='row-span-4 h-full'
        initialValues={{ password: '', password_confirmation: '' }}
      >
        <Field name='password' placeholder='Password' component={Input} />
        <Field name='password_confirmation' placeholder='Password confirmation' component={Input} />
      </FormFactory>
      <div className='row-span-1 w-full flex items-end'>
        <Button
          onClick={() => {
            console.log(formRef.current.values);
            UserService.updateProfile(formRef.current.values);
          }}
          className='w-full'
        >
          Update profile
        </Button>
      </div>
    </Screen>
  );
};

export default PasswordChangeScreen;
